import React from 'react';
import PropTypes from 'prop-types';
import matchSorter from 'match-sorter';
import styled from 'styled-components';
import { debounce } from 'lodash';
import { Input } from '../forms';
import { FilterFunnelIcon, CloseIcon } from '../Icon';
import theme from '../../../theme';


const FilterWrapper = styled.div`
  position: absolute;
  top: 45px;
  left: 0;
  right: 0;
  z-index: 10;
  height: 42px;
  border-bottom: 1px solid ${theme.colors.light};
  color: ${theme.colors.mediumLight};
  background: ${theme.colors.white};
  
  svg {
    position: absolute;
    right: 20px;
    top: 11px;
  }
  
  svg:first-child {
    position: absolute;
    left: 50px;
    top: 11px;
  }
  
  input {
    padding-left: 80px;
    background: transparent;
    color: ${theme.colors.medium};
    &::placeholder {
      color: ${theme.colors.medium};
    }
  }
`;

const withGlobalFilter = (BaseDataTable) => {
  class GlobalFilterDataTable extends React.Component { // eslint-disable-line

    constructor(props) {
      super(props);
      this.state = {
        filterValue: '',
        filtered: [],
      };
      this.escFunction = this.escFunction.bind(this);
    }

    UNSAFE_componentWillMount() {
      document.addEventListener('keydown', this.escFunction, false);
      this.debouncedFilterAll = debounce((e) => {
        const { value } = e.target;
        const filtered = [{ id: 'all', value }];
        this.setState({ filtered });
      }, 300);
    }

    componentDidMount() {
      document.addEventListener('keydown', this.escFunction, false);
    }

    onFilteredChange = (filtered) => {
      this.setState({ filtered });
    };

    // press esc button to reset the filter values
    escFunction = (event) => {
      if (event.keyCode === 27) {
        if (this.state.filterValue !== '') {
          this.clearFilterValues();
        }
      }
    };

    filterAll = (e) => {
      e.persist();
      this.setState({ filterValue: e.currentTarget.value });
      this.debouncedFilterAll(e);
    };


    clearFilterValues = () => {
      const filtered = [{ id: 'all', value: '' }];
      this.setState({ filtered, filterValue: '' });
    };


    render() {
      const { filtered } = this.state;
      const {
        columns, filterKeys, filterLabel, ...other
      } = this.props;

      const newColumns = columns.map((col) => ({ ...col, filterable: false }));

      // Add a dummy column to filter on multiple columns
      // This column is only visually hidden because otherwise the filter wouldn't work
      newColumns.push({
        Header: 'All',
        id: 'all',
        width: 0,
        resizable: false,
        sortable: false,
        getProps: () => ({
          style: { padding: '0px' },
        }),
        getHeaderProps: () => ({
          style: { padding: '0px' },
        }),
        filterMethod: (filter, rows) => {
          const result = matchSorter(rows, filter.value, {
            keys: filterKeys,
            threshold: matchSorter.rankings.CONTAINS,
          });
          return result;
        },
        filterAll: true,
      });

      return (
        <div style={{ position: 'relative' }}>
          <FilterWrapper>
            <FilterFunnelIcon />
            <Input
              value={this.state.filterValue}
              onChange={this.filterAll}
              placeholder={filterLabel}
              variant="ghost"
            />
            { this.state.filterValue
              ? <CloseIcon size="1.3em" color={theme.colors.medium} onClick={this.clearFilterValues} />
              : null }
          </FilterWrapper>
          <BaseDataTable
            {...other}
            filtered={filtered}
            defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
            onFilteredChange={this.onFilteredChange}
            filterable
            columns={newColumns}
          />
        </div>
      );
    }
  }
  GlobalFilterDataTable.propTypes = {
    filterKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    filterLabel: PropTypes.string,
  };
  GlobalFilterDataTable.defaultProps = {
    filterLabel: 'Filter by...',
  };

  return GlobalFilterDataTable;
};

export default withGlobalFilter;
